module.exports = __webpack_public_path__ + "static/img/Josaia-Delana.1e6968b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josaia-Delana.jpg
// module id = bWQg
// module chunks = 0